import { HOME_WIDGETS_PRIORITY } from '../../../components/widgets/homeWidgets/constants';
import type { HomeWidgetsPriority } from '../../../components/widgets/homeWidgets/types';
import { FREE_SPIN_PROVIDERS, HOME_WIDGET_WIDGET_TYPE_MAPPING } from '../constants';
import type { SortHomeWidgetType, Widget } from '../types';

const sortWidgetsByWeight = (a: SortHomeWidgetType, b: SortHomeWidgetType) => {
  const orderA = a.weight || 0;
  const orderB = b.weight || 0;
  if (orderA < orderB) {
    return 1;
  } else if (orderA > orderB) {
    return -1;
  } else {
    return 0;
  }
};

const sortHomeWidgets = (widgetsList: SortHomeWidgetType[], priority?: HomeWidgetsPriority) => {
  // The flag may omit keys (e.g. Bingo/CrownRips predate it) — merge it over the code defaults.
  const widgetsPriority: HomeWidgetsPriority = { ...HOME_WIDGETS_PRIORITY, ...priority };

  return [...widgetsList].sort((a, b) => {
    const orderA = widgetsPriority[a.type];
    const orderB = widgetsPriority[b.type];
    if (orderA < orderB) {
      return -1;
    } else if (orderA > orderB) {
      return 1;
    } else {
      return sortWidgetsByWeight(a, b);
    }
  });
};

export const sortWidgets = (widgets: Widget[], homeWidgetsOrder?: HomeWidgetsPriority): Widget[] => {
  const widgetsMap = new Map<string, Widget>();
  const sortTypedWidgets: SortHomeWidgetType[] = [];

  widgets.forEach((widget) => {
    widgetsMap.set(widget.id, widget);
    const type = HOME_WIDGET_WIDGET_TYPE_MAPPING[widget.type];
    if (type) {
      sortTypedWidgets.push({
        id: widget.id,
        type,
        weight: widget.data.weight,
      });
    }
  });

  const sortedHomeWidgets = sortHomeWidgets(sortTypedWidgets, homeWidgetsOrder);

  return sortedHomeWidgets.flatMap((widget) => widgetsMap.get(widget.id) ?? []);
};

export const isFreeSpinMiniGame = (provider: string) => {
  return [FREE_SPIN_PROVIDERS.BAROULETTA, FREE_SPIN_PROVIDERS.MINIGAMES].includes(provider);
};
